import moment from 'moment';

export const getCycleStartDate = (rule_cycle_start_date, cycle_week_length, currentDate = moment()) => {
    const ruleStart = moment(rule_cycle_start_date);
    const weeksSinceStart = currentDate.diff(ruleStart, 'weeks');
    const fullCyclesPassed = Math.floor(weeksSinceStart / cycle_week_length);
    return ruleStart.clone().add(fullCyclesPassed * cycle_week_length, 'weeks');
}

export const calculateWeeklyTotals = (cycleData, commonStore, cycleDetails) => {
    if (!cycleData) return [];
    const _cycleData = Object.entries(cycleData).map(([weekNumber, weekData]) => {
        let shiftCount = 0;
        let totalHours = 0;

        Object.values(weekData).forEach(dayData => {
            if (dayData.shiftCodeId) {
                const shiftInfo = commonStore.getCompanyShift(dayData.shiftCodeId);
                if (shiftInfo && shiftInfo.shift_type !== 'freeShift') {
                    shiftCount++;
                    totalHours += shiftInfo.normal_work_day || 0;
                }
            }
            if (dayData.standbyCodeId) {
                const standbyInfo = commonStore.getCompanyShift(dayData.standbyCodeId);
                if (standbyInfo) {
                    shiftCount++;
                    totalHours += Math.round(standbyInfo.normal_work_day / standbyInfo.factor) || 0;
                }
            }
        });

        return {
            week: weekNumber,
            shiftCount,
            totalHours: (totalHours / 60).toFixed(2)
        };
    });

    const getCycleStartWeekNumber = moment(cycleDetails?.startDate).isoWeek();
    const findIndex = _cycleData.findIndex(ele => parseInt(ele.week) === parseInt(getCycleStartWeekNumber))
    const slicedData = _cycleData.slice(findIndex, _cycleData.length)
    _cycleData.splice(findIndex, _cycleData.length)
    const _revisedCycleData = [...slicedData, ..._cycleData];

    return _revisedCycleData;
}

export const calculateCycleTotals = (cycleTotals, cycleDetails) => {
    if (!cycleTotals || cycleTotals.length === 0 || !cycleDetails) {
        return {
            totalShifts: 0,
            totalHours: '0.00',
            averageHours: '0.00',
            totalWeeks: 0
        };
    }

    let totalShifts = 0;
    let totalHours = 0;

    cycleTotals.forEach(week => {
        totalShifts += week.shiftCount;
        totalHours += parseFloat(week.totalHours) || 0;
    });

    const cycleStart = moment(cycleDetails.startDate);
    const cycleEnd = moment(cycleDetails.endDate);
    const totalWeeks = Math.ceil(cycleEnd.diff(cycleStart, 'weeks', true));
    const averageHours = totalWeeks > 0 ? (totalHours / totalWeeks).toFixed(2) : '0.00';

    return {
        totalShifts,
        totalHours: totalHours.toFixed(2),
        averageHours,
        totalWeeks
    };
}

export const getDayColor = (dayKey, isHoliday = false) => {
    if (isHoliday) return 'weekly-shift-day-header-holiday';
    return dayKey === 'saturday' || dayKey === 'sunday' ? 'weekly-shift-day-header-weekend' : 'weekly-shift-day-header-weekday';
};

export const getDayBgColor = (dayKey, isHoliday = false) => {
    if (isHoliday) return 'weekly-shift-day-body-holiday';
    return dayKey === 'saturday' || dayKey === 'sunday' ? 'weekly-shift-day-body-weekend' : 'weekly-shift-day-body-weekday';
};

export const isDayFixedInOtherWeeks = (dayKey, cycleData, weekNumber) => {
    if (!cycleData || !weekNumber) return false;
    return Object.entries(cycleData).some(([week, weekDays]) => {
        if (week === weekNumber.toString()) return false;
        return weekDays[dayKey]?.fixed;
    });
};

export const getAverageHoursColor = (averageHours, workHoursRuleByDepartment) => {
    const limit = workHoursRuleByDepartment?.average_overtime_limit_per_week ?
        workHoursRuleByDepartment.average_overtime_limit_per_week / 60 : 40;
    const lowerThreshold = limit - (limit * 0.3);
    const avgHrs = parseFloat(averageHours) || 0;

    if (avgHrs < lowerThreshold) {
        return 'average-hours-low';
    } else if (avgHrs > limit) {
        return 'average-hours-high';
    } else {
        return 'average-hours-normal';
    }
};
